
import pageMixin from "@/mixins/pageMixin"
import ContentBlockList from "@soenergy/frontend-library/src/components/ContentBlockList"

export default {
  components: {
    ContentBlockList
  },
  mixins: [pageMixin],
  asyncData({ params, $storyblokHelper }) {
    return $storyblokHelper.get({
      id: `blog/${params.postId}`
    })
  },
  data() {
    return {
      pageUrl: encodeURIComponent(
        process.env.VUE_APP_WEBSITE_URL + this.$route.fullPath
      )
    }
  },
  computed: {
    facebookLink() {
      return `https://www.facebook.com/sharer.php?u=${this.pageUrl}`
    },
    twitterLink() {
      return `https://twitter.com/intent/tweet?url=${this.pageUrl}`
    },
    linkedinLink() {
      return `https://www.linkedin.com/shareArticle?mini=true&url=${this.pageUrl}`
    }
  },
  methods: {
    formatDate(date) {
      return this.$dayjs(date).format("DD MMM YYYY")
    }
  },
  head() {
    return {
      title: this.content.metadata.title,
      link: [
        {
          rel: "canonical",
          href: process.env.VUE_APP_WEBSITE_URL + this.$route.path + (this.$route.path === "/" ? "" : "/")
        }
      ],
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.content.metadata.description
        },
        {
          hid: "keywords",
          name: "keywords",
          content: this.content.metaKeywords
        },
        {
          hid: "twitter:title",
          name: "twitter:title",
          content: this.content.metadata.title
        },
        {
          hid: "twitter:description",
          name: "twitter:description",
          content: this.content.metadata.description
        },
        {
          hid: "twitter:image",
          name: "twitter:image",
          content: this.$options.filters.transformImage(
            this.content.image.filename,
            "1200x630/smart"
          )
        },
        {
          hid: "twitter:image:alt",
          name: "twitter:image:alt",
          content: this.content.image.alt
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.content.metadata.title
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.content.metadata.description
        },
        {
          hid: "og:image",
          property: "og:image",
          content: this.$options.filters.transformImage(
            this.content.image.filename,
            "1200x630/smart"
          )
        },
        {
          hid: "og:image:alt",
          property: "og:image:alt",
          content: this.content.image.alt
        }
      ]
    }
  }
}
